import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import EnhancedTableToolbar from "./EnhancedTableToolbar";
import styles from "./styles";

const enhance = compose(withStyles(styles));

export default enhance(EnhancedTableToolbar);
